import { praticaRiprendiInSeguito } from "common/_redux/pratica/actions";
import { praticaRiprendiSelector } from "common/_redux/pratica/selectors";
import BftButton from "common/components/button";
import MessageModal from "common/components/message-modal";
import { authUserSelector } from "core/auth/_redux/selectors";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import { LayoutUtils } from "layout/helpers/utils";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const Header: React.FC = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();

	const [showModal, setShowModal] = useState(false);

	const steps = useAppSelector(layoutStepsSelector);

	const userInfo = useAppSelector(authUserSelector);
	const reopenPratica = useAppSelector(praticaRiprendiSelector);

	const currentStepIndex =
		steps
			?.filter((s) => !s?.hideOnMenu)
			?.findIndex(
				(s) =>
					s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
			) || 0;

	// const getMaskedEmail = (email: string | undefined) => {
	// 	if (!email) return;
	// 	return email;
	// 	TODO mascheramento da riattivare in seguito alla validazione email

	// 	const [name, dominio] = email.split('@');
	// 	const maskedName = `${name.charAt(0)}${'*'.repeat(
	// 	  name.length - 2
	// 	)}${name.charAt(name.length - 1)}`;

	// 	const lastDotIndex = dominio.lastIndexOf('.');
	// 	const firstPart = dominio.substring(0, lastDotIndex);
	// 	const secondPart = dominio.substring(lastDotIndex);
	// 	const maskedDomain = `${firstPart.charAt(0)}${'*'.repeat(
	// 	  firstPart.length - 1
	// 	)}${secondPart}`;

	// 	const emailMascherata = `${maskedName}@${maskedDomain}`;
	// 	return emailMascherata;
	// };

	const getMessageModal = () => {
		return (
			<>
				E' stata inviata un' e-mail per il recupero della pratica all' indirizzo&nbsp;
				<span className="font-weigth-bold m-0">
					{userInfo?.email || reopenPratica?.userData?.email}
				</span>
				.<br></br>
				Puoi riprendere il processo subito chiudendo il popup oppure in qualsiasi momento dal link
				che trovi nell' e-mail.
			</>
		);
	};

	const handleRiprendiClick = () => {
		dispatch(praticaRiprendiInSeguito(LayoutUtils.getLastStepBackendRef(steps, location.pathname)))
			.unwrap()
			.then((res) => {
				if (res) {
					setShowModal(true);
				}
			});
	};

	const handleModalClose = () => {
		setShowModal(false);
	};

	return (
		<>
			<div className="header-container">
				{currentStepIndex >= 1 && currentStepIndex <= 8 && (
					<div className="px-3">
						<BftButton className="btn-buffetti-secondary" onClick={handleRiprendiClick}>
							Riprendi in seguito
						</BftButton>
					</div>
				)}
			</div>

			<MessageModal show={showModal} onClose={handleModalClose} message={getMessageModal()} />
		</>
	);
};

export default Header;
